<template>
    <transition name="fade" mode="out-in">
        <section class="padding-vertical-content" id="paso-1">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.selecciona_entradas', { entradas: footer.termino_entradas }) }}</h2>
                    </div>
                    <b-col cols="12" style="min-height: 200px;">
                        <transition name="fade" mode="out-in">
                            <ContentOrLoading>
                                <SeleccionarZonaComponent
                                    v-if="! cargando_zonas"
                                    :pack="pack"
                                    :zonas="zonas"
                                    @zonaSeleccionada="zonaSeleccionada"
                                />
                            </ContentOrLoading>
                        </transition>
                    </b-col>
                </div>
            </div>
        </section>
    </transition>    
</template>

<script>
import SeleccionarZonaComponent from "@/components/frontend/packs/venta/con_recinto/components/SeleccionarZonaComponent.vue";

export default {
    props:{
        pack: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            zonas: null,
            cargando_zonas: true
        }
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        sesiones_ids() {
            const ids = [];

            this.pack.sesiones.forEach(sesion => {
                ids.push(sesion.id);
            })

            return ids;
        }
    },
    created() {
        this.getZonas();
    },
    mounted() {
        this.$scrollTo('#paso-1', 100);
    },
    methods: {
        getZonas() {
            const params = {                    
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                slug: this.pack.slug,
                sesiones_ids: this.sesiones_ids
            }

            this.$store.dispatch(this.config.getVuexAlias("front.packs.show.zonas"), params).then(res => {
                this.zonas = res.data.data;
                this.cargando_zonas = false;
            });
        },
        zonaSeleccionada(zona) {
            this.$emit('zonaSeleccionada', zona);
        }
    },
    components: {
        SeleccionarZonaComponent
    }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>